import React from 'react'
import "./Calculator.scss";
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from '@material-ui/core';
import NumberFormat from 'react-number-format';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            inputMode="decimal"
            decimalScale={2}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value ? values.value : 0.00
                    }
                });
            }}
            thousandSeparator
            isNumericString
        />
    );
}


const Cal3YC = (props) => {
    return (
        <div className="container">

            <TextField
                value={props.lifetime_working_3yc ? Number(props.lifetime_working_3yc).toFixed(2) : ""}
                onChange={(e) => props.lifetime_working_3yc_change(parseFloat(e.target.value))}
                label="Lifetime working (Hour)"
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom
                }}
            />

            <TextField
                value={props.leasing_terms ? Number(props.leasing_terms).toFixed(2) : ""}
                onChange={(e) => props.leasing_terms_change(parseFloat(e.target.value))}
                label="Leasing terms (Month)"
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom
                }}
            />

            <TextField
                value={props.price ? Number(props.price).toFixed(2) : ""}
                onChange={(e) => props.price_change(parseFloat(e.target.value))}
                label="Price"
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                        <InputAdornment position="end">{props.currency_yc}</InputAdornment>
                    )
                }}
            />

            <TextField
                value={props.resale_value ? Number(props.resale_value).toFixed(2) : ""}
                onChange={(e) => props.resale_value_change(parseFloat(e.target.value))}
                label="Resale value (%)"
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                    )
                }}
            />

            <TextField
                // value={props.interest ? Number(props.interest).toFixed(2) : ""}
                // onChange={(e) => props.interest_change(parseFloat(e.target.value))}
                value={
                    props.interest != null
                        ? Number(props.interest).toFixed(2)
                        : ""
                }
                onChange={(e) =>
                    props.interest_change(
                        e.target.value === "" ? null : parseFloat(e.target.value)
                    )
                }
                label="Interest (%)"
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                    )
                }}
            />

            <TextField
                value={props.fuel_consumption ? Number(props.fuel_consumption).toFixed(2) : props.fuel_consumption === 0 ? 0 : ""}
                onChange={(e) => props.fuel_consumption_change(parseFloat(e.target.value))}
                label="Fuel consumption (L/h)"
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom
                }}
            />

            <TextField
                value={props.fuel_price ? Number(props.fuel_price).toFixed(2) : ""}
                onChange={(e) => props.fuel_price_change(parseFloat(e.target.value))}
                label={props.currency_yc ? `Fuel price (${props.currency_yc}/L)` : "Fuel price"}
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                        <InputAdornment position="end">{props.currency_yc}</InputAdornment>
                    )
                }}
            />

            <TextField
                value={props.maintenance_cost ? Number(props.maintenance_cost).toFixed(2) : props.maintenance_cost === 0 ? 0 : ""}
                onChange={(e) => props.maintenance_cost_change(parseFloat(e.target.value))}
                label={props.currency_yc ? `Maintenance cost (${props.currency_yc}/h)` : "Maintenance cost"}
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                        <InputAdornment position="end">{props.currency_yc}</InputAdornment>
                    )
                }}
            />

            <TextField
                value={props.repair_cost ? Number(props.repair_cost).toFixed(2) : props.repair_cost === 0 ? 0 : ""}
                onChange={(e) => props.repair_cost_change(parseFloat(e.target.value))}
                label={props.currency_yc ? `Repair cost (${props.currency_yc}/h)` : "Repair cost"}
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                        <InputAdornment position="end">{props.currency_yc}</InputAdornment>
                    )
                }}
            />

            <TextField
                value={props.down_payment ? Number(props.down_payment).toFixed(2) : ""}
                onChange={(e) => props.down_payment_change(parseFloat(e.target.value))}
                label="Down payment (%)"
                variant="outlined"
                style={{ width: "100%", marginTop: "20px" }}
                name="numberformat"
                id="formatted-numberformat-input"
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                    )
                }}
            />
            <div className="container" style={{ marginTop: "160px" }}>
            </div>
        </div>

    )
}

export default Cal3YC
